import authFetch from "components/Authentication/AuthFetch"
const api_url = process.env.REACT_APP_DASHBOARD_API_URL;

export const getCategoriesResults = (params) => {
  return authFetch(api_url+"/api/categories/results"+params)
    .then(res => res.json() )
}



// WEBPACK FOOTER //
// ./src/api/internal/categories.js